module.exports = __webpack_public_path__ + "static/media/04.24d3f528.jpg";